import { Component } from '@angular/core';
import {  OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../../service/root.service';

import { Role } from '../shared/role';
import { RoleService } from '../shared/role.service';

import { ConfirmationService } from 'primeng/primeng';


@Component({
    selector: 'role-list',
    templateUrl: './role-list.component.html',
    styleUrls: ['./role-list.component.scss']
})
export class RoleListComponent implements OnInit, OnDestroy {

    @Input() selectedRole;
    @Output() selectedRoleChange = new EventEmitter();
    @Input() operation: string;
    fromRoute: boolean;

    roles: Role[];


    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;

    constructor(public rootService: RootService,
        public translate: TranslateService) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./src/app/module/role/role-list/role-list.component.ts